import { useState } from "react";
import { Checkbox } from "@/components/ui/checkbox";
import type { PackingEntry } from "@/lib/equipment/packing-list";

/** Avkrysningsliste for pakking. Avkrysningen lever bare i nettleseren og lagres ikke. */
export function PackingList({ entries }: { entries: PackingEntry[] }) {
  const [checked, setChecked] = useState<Set<string>>(new Set());
  const toggle = (id: string, on: boolean) =>
    setChecked((prev) => {
      const next = new Set(prev);
      if (on) next.add(id);
      else next.delete(id);
      return next;
    });

  return (
    <ul className="divide-y divide-border rounded-md border bg-card">
      {entries.map((e) => {
        const id = `pakk-${e.lineId}`;
        const done = checked.has(e.lineId);
        return (
          <li key={e.lineId} className="px-3 py-3 break-inside-avoid">
            <div className="flex items-start gap-3">
              <Checkbox id={id} checked={done} onCheckedChange={(on) => toggle(e.lineId, on === true)} className="mt-0.5" />
              <label htmlFor={id} className="min-w-0 cursor-pointer">
                <span className={`block font-semibold ${done ? "text-muted-foreground line-through" : ""}`}>{e.title}</span>
                {e.details.length > 0 && <span className="block text-sm text-muted-foreground">{e.details.join(" · ")}</span>}
              </label>
            </div>
            {e.parts.length > 0 && (
              <p className="mt-1 pl-7 text-sm text-muted-foreground">{e.parts.join(" · ")}</p>
            )}
          </li>
        );
      })}
    </ul>
  );
}
